import appConstants from '@/modules/broadcast-portal-post-login/app.constants';
import { useBroadcastPortalAuthStore } from '@/modules/broadcast-portal-post-login/store';
import axios, { AxiosRequestHeaders } from 'axios';
import qs from 'qs';
import { router } from '@/modules/broadcast-portal-post-login/router';

export default function configureAxios () {
    const authStore = useBroadcastPortalAuthStore();

    axios.interceptors.request.use(
		function (config) {
			let headers: Record<string, string> = {};

			config.paramsSerializer = {
				...config.paramsSerializer,
				indexes: null
			}
			// if (config.paramsSerializer) {
			// 	config.paramsSerializer.encode = (params) => qs.stringify(params, { arrayFormat: 'repeat' })
			// }

            if (authStore.auth.accessToken) {
				headers[appConstants.AUTH_TOKEN_HTTP_HEADER_NAME] = `Bearer ${authStore.auth.accessToken}`;
            }

			config.headers = {
				...config.headers,
				...headers
			} as AxiosRequestHeaders;
            
            return config;
        }
    )

    // only when logout refresh and remove auth
	// when api return 401, remove auth
	axios.interceptors.response.use(
		(response) => {
			return response
		},
		error => {
			if (!error.response) return Promise.reject(error);
			
			if (axios.isAxiosError(error)) {
				const whitelist = appConstants.AUTH_INTERCEPTOR_WHITELIST;
				const requestUrl = error.request.responseURL;
				if (whitelist.some(x => requestUrl.includes(x))) {
					return Promise.reject(error);
				}

				const { status } = error.response;
				if (status === 401) {
					authStore.logout()
					if (!error.config?.suppressAuthCheckRedirect) {
						// This unfortunately does not cater for full absolute URLs
						// we will need to see how we can enhance this in the future
						window.location.href = `${window.location.origin}${appConstants.SIGNIN_PAGE_URL}?ref=${encodeURIComponent(router.currentRoute.value.path)}`;
					}
				}
			}
			
			return Promise.reject(error);
		}
	)
}